import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
export const PillBadge = forwardRef(({ label, color, className }, ref) => (_jsx("div", Object.assign({ ref: ref, className: clsx("iui-pill-badge", color, className) }, { children: label }))));
